

































import {
	defineComponent,
	PropType,
	Ref,
	ref,
} from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import GroupReportTable from '@front-app/views/csr/communityReports/GroupReportTable.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Size, Spacing } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import {
	REPORT_TYPE,
	CommunityReportRequest,
	GroupReportData,
	fetchCommunityReport,
} from '@front-app/services/CommunityApi/CommunityReportsApi';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		GroupReportTable,
		TrForm,
	},
	props: {
		selectedGroups: {
			type: Array as PropType<string[]>,
			required: true,
		},
		startTime: {
			type: String,
			required: true,
		},
		endTime: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const reportData: Ref<GroupReportData[]> = ref([]);
		const reportStatus = useAsyncStatus();

		const runReport = async () => {
			const payload: CommunityReportRequest = {
				type: REPORT_TYPE.FILE_AND_LINK_SHARES,
				groupIds: props.selectedGroups,
				startTime: props.startTime,
				endTime: props.endTime,
			};

			reportData.value = await reportStatus.track(fetchCommunityReport(payload));
		};

		return {
			runReport,
			reportStatus,
			reportData,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
